import { NavLink, Outlet } from 'react-router-dom';

const tabs = [
  { to: '/admin/issues', label: 'Issues' },
  { to: '/admin/customers', label: 'Customers' },
  { to: '/admin/projects', label: 'Projects' },
  { to: '/admin/addresses', label: 'Addresses' },
];

export function AdminLayout(): JSX.Element {
  return (
    <div className="space-y-6">
      <nav className="flex gap-1 border-b border-gray-800 -mx-1 px-1 overflow-x-auto">
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) =>
              `px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors whitespace-nowrap ${
                isActive
                  ? 'border-red-500 text-red-400'
                  : 'border-transparent text-gray-500 hover:text-gray-200 hover:border-gray-600'
              }`
            }
          >
            {t.label}
          </NavLink>
        ))}
      </nav>
      <Outlet />
    </div>
  );
}
